import { createToken } from '../../api/api';

import { IPaymentLinkFormValues } from '../schema';
import {
  ISubmitPaymentLinkCustomer,
  ISubmitPaymentLinkPayload,
} from '../types/types';
import { PAYMENT_METHODS } from './paymentMethods';

const onlyDigits = (value: string) => value.replace(/\D/g, '');

const buildCustomer = (
  values: IPaymentLinkFormValues,
): ISubmitPaymentLinkCustomer => ({
  email: values.email.trim(),
  name: values.name.trim(),
  documentNumber: onlyDigits(values.document),
  ...(values.phone.trim() !== '' && { phone: onlyDigits(values.phone) }),
  address: {
    street: values.address,
    streetNumber: values.addressNumber,
    neighborhood: values.neighborhood,
    zipcode: onlyDigits(values.zipCode),
    city: values.city,
    state: values.state,
    ...(values.addressComplement.trim() !== '' && {
      complement: values.addressComplement,
    }),
  },
});

export const buildPaymentPayload = async (
  values: IPaymentLinkFormValues,
  planId: string,
): Promise<ISubmitPaymentLinkPayload> => {
  const paymentMethod = values.paymentMethodSelected;

  const payload: ISubmitPaymentLinkPayload = {
    payment_method: PAYMENT_METHODS[paymentMethod],
    planId,
    card: null,
    ...(values.requiresCustomerData && { customer: buildCustomer(values) }),
  }

  if (paymentMethod !== 'credit_card') return payload;

  const token = await createToken({
    card_number: values.cardNumber,
    cardholder_name: values.cardHolderName,
    card_expiration: values.cardExpiration,
    card_cvv: values.cardCvv,
  });
  return {
    ...payload,
    card: {
      token: token.id,
      last_digits: values.cardNumber.replace(/\s/g, '').slice(-4),
      expiration_date: values.cardExpiration,
      holder_name: values.cardHolderName,
      brand: token.card?.brand || '',
    },
  };
};

